import apiClient from "@/services/apiClient";


const api = apiClient;

const fileNameFromHeaders = (headers, fallback) => {
  const disposition = headers?.["content-disposition"] || "";
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const plain = disposition.match(/filename="?([^";]+)"?/i)?.[1];
  return decodeURIComponent(encoded || plain || fallback);
};
const saveBlob = (response, fallback) => {
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileNameFromHeaders(response.headers, fallback);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const certificateService = {
  list: (params) => api.get("/AdminCertificates", { params }).then((r) => r.data),
  eligible: () => api.get("/AdminCertificates/eligible-enrolments").then((r) => r.data),
  detail: (id) => api.get(`/AdminCertificates/${id}`).then((r) => r.data),
  documents: (id) => api.get(`/AdminCertificates/${id}/documents`).then((r) => r.data),
  create: (data) => api.post("/AdminCertificates", data).then((r) => r.data),
  update: (id, data) => api.put(`/AdminCertificates/${id}`, data).then((r) => r.data),
  replace: (id, data) => api.post(`/AdminCertificates/${id}/replace-document`, data).then((r) => r.data),
  reissue: (id, data) => api.post(`/AdminCertificates/${id}/reissue`, data).then((r) => r.data),
  download: async (id, fallback = "certificate.pdf") => saveBlob(await api.get(`/AdminCertificates/${id}/download`, { responseType: "blob" }), fallback),
  studentList: () => api.get("/StudentCertificates").then((r) => r.data),
  studentDownload: async (id, fallback = "certificate.pdf") => saveBlob(await api.get(`/StudentCertificates/${id}/download`, { responseType: "blob" }), fallback),
};
